import React from 'react'
import _ from 'lodash'
import { Row } from 'antd'
import { P } from 'konsys-ui'
import contents from './detail/contents'
import CompoenentRenderer from './detail/component-renderer'
import { Wrapper } from '../../components/tire-patch-components'
import { detailMode } from './constants'
import history from '../../history'

const RowRenderer = ({
  data, mutationVariables, mode, onChangeHandler, initialData, setTireInfoId, setPatchDate, tireInfoData, tirePatchStore, setTirePatchStore,
}) => data.map(v => <CompoenentRenderer mutationVariables={mutationVariables} onChangeHandler={onChangeHandler} key={v.id} data={v} mode={mode} initialData={initialData} tirePatchStore={tirePatchStore} setPatchDate={setPatchDate} setTirePatchStore={setTirePatchStore} setTireInfoId={setTireInfoId} tireInfoData={tireInfoData} />)

const DetailModeHandler = (params, mutationVariables, onChangeHandler, setTireInfoId, setPatchDate, tireInfoData, tirePatchStore, setTirePatchStore, initialData) => {
  const mode = params.mode.toUpperCase()
  switch (mode) {
    case detailMode.ADD:
      return contents.map((v, i) => (
        <Wrapper key={i}>
          <Row
            align='flex-start'
            // justify='center'
            type='flex'
            gutter={12}
            style={{ width: '100%' }}
          >
            <RowRenderer data={v} mutationVariables={mutationVariables} mode={mode} onChangeHandler={onChangeHandler} setTireInfoId={setTireInfoId} setPatchDate={setPatchDate} tireInfoData={tireInfoData} tirePatchStore={tirePatchStore} setTirePatchStore={setTirePatchStore}/>
          </Row>
        </Wrapper>
      ))
    case detailMode.EDIT:
    case detailMode.VIEW:
    {
      if (_.isUndefined(params.id)) history.push('/tire-patch')
      // mockup data
      return contents.map((v, i) => (
        <Wrapper key={i}>
          <Row
            align='flex-start'
            // justify='center'
            type='flex'
            gutter={12}
            style={{ width: '100%' }}
          >
            <RowRenderer data={v} mutationVariables={mutationVariables} mode={mode} initialData={initialData} onChangeHandler={onChangeHandler} setTireInfoId={setTireInfoId} setPatchDate={setPatchDate} tireInfoData={tireInfoData} tirePatchStore={tirePatchStore} setTirePatchStore={setTirePatchStore}/>
          </Row>
        </Wrapper>
      ))
    }
    default:
      return <P>Something went wrong!</P>
  }
}

export default DetailModeHandler
